import { render, staticRenderFns } from "./YChooseAgentArea.vue?vue&type=template&id=718ba81d&scoped=true&"
import script from "./YChooseAgentArea.vue?vue&type=script&lang=js&"
export * from "./YChooseAgentArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718ba81d",
  null
  
)

export default component.exports